export const USAGE_INBOX_MAILBOXES = 'mailboxes'
export const USAGE_INBOX_CHANNELS = 'channels'
export const USAGE_CHAT_CHANNELS = 'chatChannels'
export const USAGE_LIVE_CHAT_CHANNELS = 'liveChatChannels'
export const USAGE_SOCIAL_CHAT_CHANNELS = 'socialChatChannels'
export const USAGE_INBOX_INTEGRATIONS = 'integrations'
export const USAGE_INBOX_USERS = 'users'
export const USAGE_INBOX_TEAMS = 'teams'
export const USAGE_INBOX_SATISFACTIONS_RATINGS = 'satisfactionsRatings'
export const USAGE_INBOX_RULES = 'rules'
export const USAGE_INBOX_CUSTOM_PROFILE = 'customProfile'
export const USAGE_INBOX_CANNED_REPLIES = 'cannedReplies'
export const USAGE_INBOX_PREMIUM_INTEGRATIONS = 'premiumIntegrations'
export const USAGE_INBOX_FOLDERS = 'folders'
export const USAGE_INBOX_RULES_TIER_1 = 'rulesTier1'
export const USAGE_INBOX_RULES_TIER_2 = 'rulesTier2'
export const USAGE_INBOX_CANNED_REPLIES_TIER_1 = 'cannedRepliesTier1'
export const USAGE_INBOX_WIDGETS = 'widgets'
export const USAGE_INBOX_API_ACCESS = 'apiAccess'
export const USAGE_INBOX_WEBHOOKS = 'webhooks'
export const USAGE_INBOX_CUSTOM_FIELDS = 'customFields'
export const USAGE_INBOX_BRANDING = 'branding'

export const USAGE_KB_KBS = 'kbs'
export const USAGE_KB_ARTICLES = 'articles'
export const USAGE_KB_BRANDING = 'branding'
export const USAGE_KB_CUSTOM_SCRIPTS = 'customScripts'
export const USAGE_KB_PRIVATE = 'private'
export const USAGE_KB_SEO = 'seo'
